import React from 'react';
import KEY_CODES from 'common/KeyCodes';
import {
  StepWarningIndicator,
  StepErrorIndicator,
  StepCompletedIndicator,
  StepIndicator,
} from 'components/StepForm';

const {
  ENTER_KEY,
  SPACE_KEY,
} = KEY_CODES;
const isSelectionKeyPressed = key => key && (key === ENTER_KEY || key === SPACE_KEY);

const getIndicatorForVariant = (variant, stepNumber, theme, iconProps = {}) => {
  const isNonLinear = stepNumber === undefined;
  let variantIcon = <StepIndicator theme={theme} $isNonLinear={isNonLinear} variant="future" {...iconProps} />;
  switch (variant) {
    case 'current':
      variantIcon = <StepIndicator theme={theme} {...iconProps} >{stepNumber}</StepIndicator>;
      break;
    case 'future':
      variantIcon = <StepIndicator theme={theme} $isNonLinear={isNonLinear} variant="future" {...iconProps} >{stepNumber}</StepIndicator>;
      break;
    case 'error':
      variantIcon = <StepErrorIndicator theme={theme} {...iconProps} />;
      break;
    case 'warning':
      variantIcon = <StepWarningIndicator theme={theme} {...iconProps} />;
      break;
    case 'completed':
      variantIcon = <StepCompletedIndicator theme={theme} {...iconProps} >{stepNumber}</StepCompletedIndicator>;
      break;
    default:
      variantIcon = undefined;
  }
  return variantIcon;
};

const getPressedColor = (resolvedTheme, variant, hovered) => {
  let pressedColor = hovered ? resolvedTheme.pressed.hovered.background : resolvedTheme.pressed.background;
  switch (variant) {
    case 'current':
      pressedColor = resolvedTheme.selected.pressed.background;
      break;
    case 'error':
      pressedColor = hovered ? resolvedTheme.error.pressed.hovered.background : resolvedTheme.error.pressed.background;
      break;
    default:
      pressedColor = hovered ? resolvedTheme.pressed.hovered.background : resolvedTheme.pressed.background;
  }
  return pressedColor;
};

export {
  getIndicatorForVariant,
  getPressedColor,
  isSelectionKeyPressed,
};